import { z } from "zod";

// Skema untuk satu item data dalam laporan negara V4
const CountryReportDataV4Schema = z.object({
    country: z.string().nullable(),
    nb_reservations: z.number(),
    amount: z.string().transform(val => parseFloat(val)),
});

// Skema untuk objek 'total' dalam respons V4
const CountryReportTotalV4Schema = z.object({
    nb_reservations: z.number(),
    amount: z.string().transform(val => parseFloat(val)),
});

// Skema utama untuk keseluruhan respons API V4
export const CountryReportResponseV4Schema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number(),
    data: z.array(CountryReportDataV4Schema),
    total: CountryReportTotalV4Schema,
});

// Ekspor tipe TypeScript yang diambil dari skema Zod
export type CountryReportResponseV4 = z.infer<typeof CountryReportResponseV4Schema>;
export type CountryReportDataV4 = z.infer<typeof CountryReportDataV4Schema>;